export default {
  'zh-CN': {
    uploadFiles: '上传附件',
    supportExtension: '支持扩展名',
    files: '已上传{upNum}个文件，还可以上传{remainNum}个文件'
  },
  'en': {
    uploadFiles: 'Upload attachment',
    supportExtension: 'Extensions supported',
    files: '已上传{upNum}个文件，还可以上传{remainNum}个文件'
  }
}
